import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "mb-3 flex items-start gap-2 rounded-lg border border-negative bg-negative/5 p-3 text-sm text-textPrimary",
  "data-testid": "prefill-error-state"
}
const _hoisted_2 = {
  class: "mt-0.5 h-4 w-4 shrink-0 text-negative",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_3 = ["d"]
const _hoisted_4 = { class: "min-w-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", {
  class: "font-bold",
  "data-testid": "prefill-error-title"
}, " Não conseguimos carregar o espelho da escala. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, " As linhas já enviadas continuam salvas. Tente de novo antes de digitar — digitar agora pode duplicar linhas. ", -1)
const _hoisted_7 = {
  key: 0,
  class: "mt-1 text-neutral50",
  "data-testid": "prefill-error-detail"
}
const _hoisted_8 = { class: "mt-3 flex flex-wrap items-center gap-4" }

import { mdiAlertCircleOutline } from '@mdi/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendancePrefillErrorState',
  props: {
    message: { default: null },
    canRetry: { type: Boolean, default: true },
    showClassicEscape: { type: Boolean, default: false }
  },
  emits: ["retry", "useClassic"],
  setup(__props: any, { emit }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("path", {
        d: _unref(mdiAlertCircleOutline),
        fill: "currentColor"
      }, null, 8, _hoisted_3)
    ])),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _hoisted_6,
      (_ctx.message)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.message), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.canRetry)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "rounded bg-primary px-4 py-2 font-bold text-white",
              "data-testid": "prefill-error-retry",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('retry')))
            }, " Tentar novamente "))
          : _createCommentVNode("", true),
        (_ctx.showClassicEscape)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "font-bold text-primary underline",
              "data-testid": "prefill-error-classic",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('useClassic')))
            }, " Digitar sem espelho "))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})